"use es6";

import { useLayoutEffect, useEffect } from 'react';
import { isBrowser } from "./is-browser";
const useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;
export { useIsomorphicLayoutEffect };